import db from "./firebaseApp";
import { 
  doc,
  collection, 
  query, 
  orderBy,
  addDoc,
  updateDoc,
  getDoc,
  getDocs,
} from 'firebase/firestore'
import { utilMethods } from '../utils/utilMethods';


// firebase Firestore helper methods go here... 

export const firestoreMethods = {
  /*
  getVenue: async (venueId) => {
    try {

      const docRef = doc(db, "venues", venueId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        utilMethods.customLog(`retrieved venue: ${docSnap.data().name}`);
        return {...docSnap.data(), id: docSnap.id};
      } else {
        utilMethods.customLog(`No Such Doc ${venueId}`);
      }
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> getVenue -> error ${err}`);
    }
  },

  getVenues: async () => {
    try {
      const q = query(
        collection(db, "venues"), 
        orderBy("name")
      );
      const querySnapshot = await getDocs(q);
      let venues = [];
      querySnapshot.forEach((doc) => {
        venues.push({...doc.data(), id: doc.id});
      });

      utilMethods.customLog(`retrieved ${venues.length} venues`);
      return venues;
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> getVenues -> error ${err}`);
    }
  },

  getPipe: async () => {
    try {
      const q = query(
        collection(db, "venues"), 
        orderBy("name")
      );
      const querySnapshot = await getDocs(q);
      let venues = [];
      querySnapshot.forEach((doc) => {
        venues.push({...doc.data(), id: doc.id});
      });

      utilMethods.customLog(`retrieved ${venues.length} venues`);
      return venues;
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> getPipe -> error ${err}`);
    }
  },

  updateVenue: async (venueId, inputs) => {
    try {
      // update dbUser with the restaurant
      const venueRef = doc(db, "venues", venueId);
      let updateObj = {};
      for( let changeKey of Object.keys(inputs) ) {
        //console.log("changeKey", changeKey);
        updateObj[changeKey] = inputs[changeKey];
      }

      await updateDoc(venueRef, updateObj);
      utilMethods.customLog(`updated venue: ${venueId} name: ${inputs.name} updates: ${Object.keys(updateObj)}`);
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> updateVenue -> error ${err}`);
    }
  },

  updateVenuePipeSetup: async (venue, stage, inputs) => {
    utilMethods.customLog(`venue: ${venue.id} stage: ${stage} inputs: ${Object.keys(inputs)}`);

    try {
      // update dbUser with the restaurant
      const venueRef = doc(db, "venues", venue.id);

      // default the pipe and stage 
      if (!venue["zz_pipe"]) {
        venue["zz_pipe"] = {};
      }
      if (!venue.zz_pipe[stage]) {
        venue.zz_pipe[stage] = {};
      }
      for( let changeKey of Object.keys(inputs) ) {
        console.log("changeKey: ", changeKey);
        console.log("changeVal: ", inputs[changeKey]);
        venue.zz_pipe[stage][changeKey] = inputs[changeKey];
      }
      let updateKey = "zz_pipe." + stage;
      let updateObj = {[updateKey]: venue.zz_pipe[stage]};
      await updateDoc(venueRef, updateObj);
      utilMethods.customLog(`updated venue: ${venue.id} name: ${inputs.name} updates: ${Object.keys(updateObj)}`);
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> updateVenuePipeSetup -> error ${err}`);
    }
  },

  /*/

  addSite: async (site) => {
    try {
      site["date"] = new Date();
      const siteRef = await addDoc(collection(db, "sites"), site);
      utilMethods.customLog(`added site: ${site.name} id: ${siteRef.id}`);
      return siteRef.id;
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> addSite -> error ${err}`);
    }
  },

  updateSite: async (siteId, inputs) => {
    try {
      const siteRef = doc(db, "sites", siteId);
      let updateObj = {};
      for( let changeKey of Object.keys(inputs) ) {
        //console.log("changeKey", changeKey);
        updateObj[changeKey] = inputs[changeKey];
      }

      await updateDoc(siteRef, updateObj);
      utilMethods.customLog(`updated site: ${siteId} name: ${inputs.name} updates: ${Object.keys(updateObj)}`);
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> updateSite -> error ${err}`);
    }
  },

  getSite: async (siteId) => {
    try {

      const docRef = doc(db, "sites", siteId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        utilMethods.customLog(`retrieved site: ${docSnap.data().name}`);
        return {...docSnap.data(), id: docSnap.id};
      } else {
        utilMethods.customLog(`No Such Doc ${siteId}`);
      }
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> getSite -> error ${err}`);
    }
  },

   getSites: async () => {
    try {
      const q = query(
        collection(db, "sites"), 
        orderBy("name")
      );
      const querySnapshot = await getDocs(q);
      let sites = [];
      querySnapshot.forEach((doc) => {
        sites.push({...doc.data(), id: doc.id});
      });

      utilMethods.customLog(`retrieved ${sites.length} sites`);
      return sites;
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> getSites -> error ${err}`);
    }
  },

  getSiteSteps: async (siteId) => {
    console.log("siteId:", siteId);
    let returnSteps = null;
    switch (siteId) {
      case '4xhBtHgNZREtm0SaDXZv': // amex
        returnSteps = [
          {
            op: "doDebMagic",
          },
        ]
        break;
      case 'EmMtW8BUS3QN0ljMHaTQ': //chase
        returnSteps = [
          {
            elem: "edit-primary-address-link-0",
            op: "byId",
          },
          {
            op: "click",
          },
          {
            op: "doYoMagic",
          },

        ]
        break;
      case 'Kmdd1AEiVya2TImN02hO': // Google
        returnSteps = [
          {
            op: "querySelector",
            elem: "input[aria-label='Address input field']", //'[aria-label="Address input field"]'
          },
          {
            op: "typeFullAddy",
          },
        ]
        break;
      
      default:
        console.log(`No match for ${siteId}.`);
    }

    return returnSteps;
    
  },

  getUser: async (userId) => {
    try {

      const docRef = doc(db, "users", userId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        utilMethods.customLog(`retrieved user: ${docSnap.data().firstName}`);
        return {...docSnap.data(), id: docSnap.id};
      } else {
        utilMethods.customLog(`No Such Doc ${userId}`);
      }
    } catch (err) {
      utilMethods.customLog(`firestoreMethods -> getUser -> error ${err}`);
    }
  },

  
}